import type { RefObject } from "react";
import type { ExpandedState } from "@tanstack/react-table";
import { Button } from "@design-system/Button/Button";
import { CollapseIcon, ExpandIcon } from "@icons";
import type { DataGridHandle } from "../useTableHandle";

interface ExpandAllButtonProps {
    expanded: ExpandedState;
    handleRef: RefObject<Pick<
        DataGridHandle,
        "expandAll" | "collapseAll"
    > | null>;
}

/** Toolbar part that expands or collapses every row; works outside the grid root. */
export const ExpandAllButton = ({
    expanded,
    handleRef,
}: Readonly<ExpandAllButtonProps>) => {
    const isAllCollapsed =
        expanded !== true && Object.values(expanded).every((isOpen) => !isOpen);
    return (
        <Button
            iconOnly
            variant="primary"
            size="md"
            aria-label={isAllCollapsed ? "Expand all" : "Collapse all"}
            onClick={() =>
                isAllCollapsed
                    ? handleRef.current?.expandAll()
                    : handleRef.current?.collapseAll()
            }
        >
            {isAllCollapsed ? <ExpandIcon /> : <CollapseIcon />}
        </Button>
    );
};
